import { render, staticRenderFns } from "./ThreeaseProIcon.vue?vue&type=template&id=2861ae48&"
import script from "./ThreeaseProIcon.vue?vue&type=script&lang=ts&"
export * from "./ThreeaseProIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports